module.exports = __webpack_public_path__ + "f73ce6e975391ae2f060fb342be08de7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-8.png
// module id = 2684
// module chunks = 0